import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopManagerRoutingModule } from './shop-manager-routing.module';
import { ShopModule } from '../modules/shop/shop.module';
import { ElementsModule } from "../shared/elements/elements.module";
import { icons, LucideAngularModule } from 'lucide-angular';
import { MaterialModule } from '../shared/material/material.module';
import { ShopManagerComponent } from './shop-manager.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { EventManagementModule } from '../modules/event-management/event-management.module';


@NgModule({
  declarations: [
    ShopManagerComponent
  ],
  imports: [
    CommonModule,
    ShopManagerRoutingModule,
    ElementsModule,
    MaterialModule,
    ShopModule,
    NgxIntlTelInputModule,
    LucideAngularModule.pick(icons),
    EventManagementModule,
]
})
export class ShopManagerModule { }
